import type { CSSProperties } from "react";
import { Toaster as SonnerToaster } from "sonner";
import { useTheme } from "../theme-provider";

/** Mount once per application, outside routes so notifications survive navigation. */
export function Toaster() {
  const theme = useTheme();
  return (
    <SonnerToaster
      theme={theme?.resolvedTheme ?? "light"}
      position="bottom-right"
      richColors
      closeButton
      duration={5000}
      visibleToasts={3}
      offset={24}
      mobileOffset={16}
      containerAriaLabel="Уведомления"
      toastOptions={{ closeButtonAriaLabel: "Закрыть уведомление" }}
      style={
        {
          fontFamily: "inherit",
          "--normal-bg": "var(--color-card)",
          "--normal-text": "var(--color-card-foreground)",
          "--normal-border": "var(--color-border)",
          "--success-bg": "var(--color-accent)",
          "--success-text": "var(--color-accent-foreground)",
          "--success-border": "var(--color-primary)",
          "--error-bg": "var(--color-card)",
          "--error-text": "var(--color-destructive)",
          "--error-border": "var(--color-destructive)",
        } as CSSProperties
      }
    />
  );
}
